export const openEditInsuranceDialog = () => ({ type: 'OPEN_EDIT_INSURANCE_DIALOG' })

export const closeEditInsuranceDialog = () => ({ type: 'CLOSE_EDIT_INSURANCE_DIALOG' })
